const menuCmsHeaderBodyClass = "menu-cms-header-view";
export {
  menuCmsHeaderBodyClass
};
